module.exports = __webpack_public_path__ + "static/media/ach.200528e9.svg";